import React, { useEffect } from 'react'
import Neet_Banner from './Neet_Banner'
import axios from 'axios';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import NeetCards from './NeetCards';
import Neet_StudyMaterials from './NeetStudyMaterials';
import NeetTestSeriesCards from './NeetTestSeriesCards';
import { useLocation } from 'react-router-dom';

const NeetHomePage = () => {
    const location = useLocation();
    const path=location.pathname;
    const [courses, setCourses] = React.useState([]);
    const [testSeries, setTestSeries] = React.useState([]);
    const [studyMaterials, setStudyMaterials] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState('classes');
    console.log(testSeries);
    useEffect(() => {
        document.title = "NEET| Classes, Study Material, Test Series";
        const fetchNeetData = async () => {
            try {
                const [coursesRes, testSeriesRes, studyMaterialsRes] = await Promise.all([
                    axios.get(BASE_URL + '/neet/user/courses'),
                    axios.get(BASE_URL + '/neet/user/testseries'),
                    axios.get(BASE_URL + '/neet/user/study-materials')
                ]);
                setCourses(coursesRes.data.data);
                setTestSeries(testSeriesRes.data.data);
                setStudyMaterials(studyMaterialsRes.data.data);
            } catch (error) {
                console.error("Error fetching NEET data:", error);
            }
        };

        fetchNeetData();
    }, []);
    return (
        <div>
            <Neet_Banner selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
            {path === '/neet/classes' && <NeetCards courses={courses} heading="Neet Courses" />}
            {path === '/neet/study-material' && <Neet_StudyMaterials studyMaterials={studyMaterials} heading="Neet Courses" />}
            {path === '/neet/testseries' && <NeetTestSeriesCards testSeries={testSeries} heading="Neet Test Series" />}
        </div>
    )
}

export default NeetHomePage